<div #pbiContainer></div>
<div *ngIf="render_complete" style="display: none" id="render_complete"></div>
